import * as React from 'react'
const chalk = require('chalk');

const success = (location?: string, message?: any) => console.log(location, chalk.green(message));
const info = (location?: string, message?: any) => console.log(location, chalk.blue(message));
const error= (location?: string, message?: any) => console.log(location, chalk.red(message));

export default { success, info, error };